<template>
    <section id="modal-files-service-quote">
      <loading-flux :value="loading"></loading-flux>
      <v-dialog v-model="modalAction" max-width="1200px" scrollable @keydown="executeModalFilesService"
        @click:outside="executeModalFilesService">
        <v-card>
          <div class="p-4 pb-0" v-if="currentService">
            <h5>
              Documentos de la Cotización: <b>{{ currentService.name }}</b>
            </h5>
          </div>
          <hr />
          <v-card-text>
            <v-container class="">
              <v-tabs v-if="currentService" v-model="tabsFiles" fixed-tabs>
                <v-tabs-slider></v-tabs-slider>
                <v-tab class="" value="quotes">
                  Cotizaciones
                </v-tab>
                <v-tab value="other">
                  Otros Documentos
                </v-tab>
              </v-tabs>
              <section v-if="currentService" class="mt-3">
                <v-simple-table :key="keyDocumentsTable" class="my-12" v-if="documentFilesFromCategory.length">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nombre
                        </th>
                        <th class="text-left" v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes && !userCreateRequestQuote
                          ">
                          Tasa de Cambio Utilizada
                        </th>
                        <th class="text-left" v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes && userCreateRequestQuote
                          ">
                          Tipo de Cambio
                        </th>
                        <th class="text-left" v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          Precio Neto
                        </th>
                        <th class="text-left" v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          Precio Neto en Pesos
                        </th>
                        <th class="text-center" v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          Proveedor
                        </th>
                        <th class="text-left" v-if=" 
                          tabsFiles == QUOTE_CONSTANTS.document_category_quotes 
                          ">
                          Exento de IVA
                        </th>
                        <th class="text-center">
                          Acción
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="document in documentFilesFromCategory" :key="document.id">
                        <!-- Columna de Nombre de Archivo -->
                        <td>
                          <a v-if="!userCreateRequestQuote" @click.prevent="downloadFile(document)" class="text-primary">
                            <div class="d-flex align-items-center my-1">
                              <v-icon color="red" class="mx-2">
                                mdi-file-pdf
                              </v-icon>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <p v-bind="attrs" v-on="on" class="my-2">
                                    {{ document.document_name }}
                                  </p>
                                </template>
                                <span>Descargar archivo</span>
                              </v-tooltip>
                            </div>
                          </a>
                          <div v-else class="d-flex align-items-center justify-content-start">
                            <v-icon color="red" class="mr-2">
                              mdi-file-pdf
                            </v-icon>
                            <p class="my-2 font-weight-bold">
                              {{ document.file.name }}
                            </p>
                          </div>
                        </td>
                        <!-- Columna de Tipo de Cambio -->
                        <td v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          <p class="my-0 mt-1" style="font-size: 12px">
                            {{ document.coin == REQUEST_SERVICE_CONSTANTS.coin_types[0].value ? '---' : document.exchange_rate }}
                          </p>
                        </td>
                        <!-- Columna de Precio -->
                        <td v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          <section class="text-left d-flex align-items-center"
                            v-if="userCreateRequestQuote || currentDocumentEdit == document.id">
                            <v-select @change="sendUpdateExchangeRates(document)" v-model="document.coin" :items="REQUEST_SERVICE_CONSTANTS.coin_types"
                              item-text="text" item-value="value" style="max-width: 60px"
                              class="font-size-12 mr-3 mb-1" />
  
                            <small class="mr-1">
                              {{ REQUEST_SERVICE_CONSTANTS.getCurrencySymbol(document.coin) }}
                            </small>
                            <input v-if="userCreateRequestQuote" class="form-control-quantity" type="text"
                              v-model="document.price" @blur="sendUpdateExchangeRates(document)" @input="formatPrice(document)" hide-details />
                            <input v-else class="form-control-quantity" type="text" v-model="currentDocumentPrice"
                              @input="formatCurrentDocumentPrice()" hide-details />
  
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="updatePriceQuotation(document)" v-if="currentDocumentEdit == document.id"
                                  v-on="on" v-bind="attrs" icon :disabled="loadingDocument" x-small class="pointer mx-1">
                                  <v-icon color="primary" class="">
                                    mdi-send
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>
                                Confirmar modificación de precio
                              </span>
                            </v-tooltip>
                          </section>
                          <p v-else class="my-0 mt-1" style="font-size: 12px">
                          <section class="d-flex align-items-center">
                            {{
                              `${document.price ?
                                document.price.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g,
                                  '#').replace(/,/g, '.').replace(/#/g, ',')
                                : 0}
                            ${document.coin ? document.coin : "CLP"}`
                            }}
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="setCurrentDocumentEdit(document)"
                                  v-if="activeEditPriceAndSupplierFiles && currentDocumentEdit != document.id"
                                  v-bind="attrs"
                                  icon
                                  :disabled="loadingDocument"
                                  x-small
                                  color="red"
                                  class="pointer mx-1"
                                  v-on="on"
                                >
                                  <v-icon color="orange" class="">
                                    mdi-pencil
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{
                                document.price
                                  ? "Modificar precio neto"
                                  : "Cotizar Precio neto"
                              }}</span>
                            </v-tooltip>
                          </section>
                          </p>
                        </td>
                        <!-- Columna de Monto -->
                        <td v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          <p v-if="document.coin == REQUEST_SERVICE_CONSTANTS.coin_types[0].value || currentDocumentEdit == document.id" class="my-0 mt-1" style="font-size: 12px">
                            ---
                          </p>
                          <p v-else class="my-0 mt-1" style="font-size: 12px">
                            {{ document.amount ? document.amount : "-" }} CLP
                          </p>
                        </td>
                        <!-- Columna de Proveedor -->
                        <td v-if="
                            tabsFiles ==
                              QUOTE_CONSTANTS.document_category_quotes
                          ">
                          <span v-if="document.supplier_name || document.supplier_rut || document.supplier" class="d-flex align-items-center justify-content-center">
                            {{ document.supplier_name ? document.supplier_name : document.supplier_rut ?
                            document.supplier_rut : document.supplier }}
                          <!-- Modificar proveedor normal -->
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="openModalSearchSupplier(document)" v-if="activeEditPriceAndSupplierFiles"
                                  v-on="on" v-bind="attrs" icon x-small :disabled="loadingDocument" color="red"
                                  class="pointer">
                                  <v-icon color="orange" class="">
                                    mdi-pencil
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>Modificar Proveedor</span>
                          </v-tooltip>
                          </span>
                          <v-btn v-else-if="userCreateRequestQuote || (uploadFiles && activeEditPriceAndSupplierFiles)"
                            small color="primary" class="" :disabled="loadingDocument"
                            @click="openModalSearchSupplier(document)">
                            <v-icon small class="mr-1" color="white">
                              mdi-account-plus
                            </v-icon>
                            <span class="mt-px">
                              Agregar Proveedor
                            </span>
                          </v-btn>
                          <span v-else>
                            -
                          </span>
                          
                        </td>
                         <!-- Columna de EXENTO DE IVA -->
                        <td
                        v-if="tabsFiles == QUOTE_CONSTANTS.document_category_quotes">
                          <div class="d-flex justify-content-center">
                            <v-checkbox :disabled="!uploadFiles || currentRequestStatusIsRejected || currentRequestStatusIsFinished || (currentRequestStatusIsUserValidationVariant && currentRequest.approved) || (currentRequestStatusIsQuotation && requestingUserModule)" :input-value="document.tax_exempt"
                              @change="updateTaxExemptDocument(document)">
                            </v-checkbox>
                          </div>
                        </td>
                        <td >
                          <v-btn v-if="(
                          userCreateRequestQuote || 
                          activeManagmetFiles
                        ) && permissionToDeleteFile(document)" icon color="red darken-2" small
                            @click="userCreateRequestQuote ? deleteFile(document) : deleteUploadFile(document)">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <p class="text-center my-5 pt-5" v-else>
                  Sin Archivos Cargados
                </p>
                <section class="d-flex align-items-center justify-content-center" v-if="loadingDocument">
                  <v-progress-circular class="mx-2" indeterminate color="primary"></v-progress-circular>
                  <span>
                    Actualizando Documento
                  </span>
                </section>
              </section>
               
              <section class="mt-8" v-if="((userCreateRequestQuote || activeManagmetFiles) || (
                  uploadFiles &&
                    ((!requestingUserModule &&
                    currentServiceStatusIsQuotationOrInReview))
                ))">
                <v-file-input accept="application/pdf" multiple counter show-size chips deletable-chips
                  placeholder="Puedes Cargar Aquí los Documentos del Servicio" :value="form.files" @change="updateFiles"
                  @click:clear="form.files = []"></v-file-input>
                <!-- Botón deshabilitado si no hay archivos ni hay usuario especializado -->
                <v-btn class="mt-5 float-right" color="primary" shaped small :disabled="!form.files.length || !canUploadQuoteFiles"
                  @click="userCreateRequestQuote ? updateFilesService() : updateFilesUploadService()">
                  Cargar Archivos
                  <v-icon class="ml-2" small>
                    mdi-send
                  </v-icon>
                  <v-tooltip top v-if="!canUploadQuoteFiles && currentService">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small class="ml-2" color="warning" v-bind="attrs" v-on="on">
                        mdi-alert-circle-outline
                      </v-icon>
                    </template>
                    <span>La cotización debe tener un usuario especializado asignado</span>
                  </v-tooltip>
                </v-btn>
              </section>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" outlined @click="executeModalFilesService">
              <small>
                Cerrar
              </small>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <table-add-supplier ref="tableAddSupplier" :modalAction="dialogAddSupplier"
        :closeModalTableAddSupplier="closeModalTableAddSupplier" :currentDocument="currentDocument"
        @addSupplierSelected="addSupplierSelected" @openModalCreateSupplier="openModalCreateSupplier"
        @openModalSetOnlyRutSupplier="openModalSetOnlyRutSupplier" :typeRequestService="typeRequestService">
      </table-add-supplier>
      <search-supplier ref="searchSupplier" :modalAction="dialogSearchSupplier"
        :closeModalSearchSupplier="closeModalSearchSupplier" :onlyRut="onlyRut" @emitSearch="openModalAddSupplier"
        @addSupplier="addSupplierSelected">
      </search-supplier>
      <modal-create-supplier :modalAction="dialogCreateSupplier" :closeModalCreateSupplier="closeModalCreateSupplier"
        :showOnlyCompleteSupplier="true" @emitNameSupplier="addSupplierSelected">
      </modal-create-supplier>
    </section>
  </template>
  
  <script>
    import { mapActions } from "vuex";
    import swal2 from "sweetalert2";
  import {
    preventCloseIfNotKeyEventEsc,
    renameAndReturnNewFile,
  } from "@/helpers/common";
  import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
  import { REQUEST_SERVICE } from "@/constants/requestMaterial";
  import { authUsuarioComputed } from "@/state/helpers";
  import TableAddSupplier from '../TableAddSupplier.vue';
  import SearchSupplier from '@/components/commons/SearchSupplier.vue';
  import ModalCreateSupplier from '../../../supplying/formSuppliers/components/ModalCreateSupplier.vue';
  import exchangeRateMixin from "@/mixins/exchangeRate";
  import QUOTE_CONSTANTS from '@/constants/quotes';
  export default {
    mixins: [exchangeRateMixin],
    components: { TableAddSupplier, SearchSupplier, ModalCreateSupplier },
    props: {
      modalAction: {
        type: Boolean,
        default: false,
      },
      closeModalFilesService: {
        type: Function,
        default: () => {},
      },
      currentService: {
        default: null,
      },
      requestId: {
        default: null,
      },
      currentRequest: {
        default: null,
      },
      requestingUserModule: {
        type: Boolean,
        default: false,
      },
      uploadFiles: {
        type: Boolean,
        default: true,
      },
      typeRequestService: {
        default: REQUEST_SERVICE,
      },
      userCreateRequestQuote: {
        type: Boolean,
        default: true
      },
    },
data() {
      return {
        keyDocumentsTable: new Date().getTime(),
        loading: false,
        loadingDocument: false,
        tabsFiles: "quotes",
        REQUEST_SERVICE_CONSTANTS,
        QUOTE_CONSTANTS,
        form: {
          files: [],
        },
        // Add Supplier
        onlyRut: false,
        dialogAddSupplier: false,
        dialogCreateSupplier: false,
        dialogSearchSupplier: false,
        currentDocument: null,
        // Edit Document
        currentDocumentEdit: null,
        currentDocumentPrice: null,
      };
    },
    methods: {
      ...mapActions({
        sendDeleteFile: "requestService/deleteFileService",
        sendUpdateFilesService: "quote/updateService",
        sendUpdateService: "quote/updateService",
      }),
      async downloadFile(documentFile) {
        try {          
          const response = await fetch(documentFile.document_path.replace(/%/g, "%25"), {
            method: "GET",
          });
          const blob = await response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = documentFile.document_name;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
          console.log(error)
        }
    },
      //Obtener tipo de cambio para monedas distintas a CLP
      async sendUpdateExchangeRates(item) {
        if(this.userCreateRequestQuote && item.coin && item.coin !== REQUEST_SERVICE_CONSTANTS.coin_types[0].value && item.price){
          const itemExchangeRate = await this.mapExchangeRate([item]);
          this.$emit('updateExchangeRateCurrentService', itemExchangeRate[0]);
        }
      },
      async selectDocument(document) {
        let self = this
        if(this.userCreateRequestQuote){
          this.currentService.documents.forEach((file) => {
            if (file.id == document.id) {
              file.selected = !file.selected;
            }else {
              file.selected = false;
            }
          });
          this.keyDocumentsTable++;
        }else {
          await this.updateService({
            [document.document_name]: {
              action: 'update',
              comment: "Modificación de selección",
              selected: !document.selected,
              supplier: document.supplier,
              type: document.document_type,
              unit_price: document.price,
              coin: document.coin ? document.coin : "CLP",
              unique_supplier: document.unique_supplier,
            }
          });
          this.keyDocumentsTable++;
        }
      },
      async updateTaxExemptDocument(document) {
        let self = this
        if(this.userCreateRequestQuote){
          this.currentService.documents.forEach((file) => {
            if (file.id == document.id) {
              file.tax_exempt = !file.tax_exempt;
            }else {
              file.tax_exempt = false;
            }
          });
          this.keyDocumentsTable++;
        }else {
          await this.updateService({
            [document.document_name]: {
              action: 'update',
              comment: "Modificación de Exento de IVA",
              selected: document.selected,
              supplier: document.supplier,
              type: document.document_type,
              unit_price: document.price,
              coin: document.coin ? document.coin : "CLP",
              unique_supplier: document.unique_supplier,
              tax_exempt: !document.tax_exempt,
            }
          });
          this.keyDocumentsTable++;
        }
      },
      executeModalFilesService($event) {
        let validationEvent = preventCloseIfNotKeyEventEsc($event);
        if (validationEvent) {
          this.form.files = [];
          this.closeModalFilesService($event);
        }
      },
      formatCurrency(value) {
        if(value) {
          let sanitizedValue = String(value).replace(/[^\d,]/g, '');
          let number = parseFloat(sanitizedValue.replace(/,/g, '.'));
  
          if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
            return value;
          }
          if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
            return value;
          }
  
          return number.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
        } else {
         return value;
        }
      },
      formatPrice(document) {
        document.price = this.formatCurrency(document.price);
      },
      formatCurrentDocumentPrice() {
        this.currentDocumentPrice = this.formatCurrency(this.currentDocumentPrice);
      },
      updateFiles(newFiles) {
        if (
          newFiles.length &&
          newFiles.find((file) => file.type !== "application/pdf")
        ) {
          this.form.files = [];
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "Solo se permiten archivos de formato PDF",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        if (newFiles.length && newFiles !== this.form.files) {
          this.form.files = [...this.form.files, ...newFiles];
        }
      },
      updateFilesService() {
        if (this.form.files !== this.currentService.documents) {
          let fileNameDuplicated = false;
          this.form.files.forEach((file) => {
            if (
              this.currentService.documents.find(
                (document) => document.file.name === file.name
              )
            ) {
              fileNameDuplicated = true;
            }
          });
          if (fileNameDuplicated) {
            return swal2.fire({
              icon: "error",
              title: "Error",
              text: "Ya existe un archivo con el mismo nombre",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 5000,
              timerProgressBar: true,
            });
          }
          this.currentService.documents = [
            ...this.currentService.documents,
            ...this.form.files.map((item, index) => ({
              file: item,
              id: new Date().getTime() + index,
              category: this.tabsFiles,
              coin: "CLP",
            })),
          ];
        }
        this.form.files = [];
      },
      async updateFilesUploadService() {
        let self = this;
        // Inicializar bandera de carga y variables para el payload
        self.loading = true;
        let filesToUpload = [];
        let payload = {
          quotation_id: self.requestId,
          user: self.user.email,
          title: self.currentService.title,
          description: self.currentService.name,
          documents: self.form.files.reduce((acc, cur, index) => {
            let filename = `${new Date().getTime() + index}_${cur.name}`;
            let fileWithNewName = renameAndReturnNewFile(cur, filename);
            acc[filename] = {
              action: 'add',
              comment: "Archivo cargado",
              selected: false,
              unique_supplier: false,
              supplier: null,
              type: QUOTE_CONSTANTS.getTypeDocumentFromFile(
                cur.category ? cur.category : {category: self.tabsFiles},
              ),
              unit_price: 0,
              coin: 'CLP',
            };
            filesToUpload.push(fileWithNewName);
            return acc;
          }, {}),
        };
        payload.files = filesToUpload;
        // Bloque try/catch para manejar errores del servidor 400 y conexiones fallidas
        try {
          // Ejecutar petición HTTP PUT para actualizar cotización
          const resp = await self.sendUpdateFilesService(payload);
          if (resp?.status == 200) {
            swal2.fire({
              icon: "success",
              title: "Excelente",
              text: "Documentos agregados correctamente",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 5000,
              timerProgressBar: true,
            });
            self.form.files = [];
            self.$emit("filesUploaded", self.currentService);
          } else if (resp?.status === 400) {
            self.loading = false;
            // Acceso seguro a resp.data.detail con fallback descriptivo
            const errorDetail = resp?.data && resp?.data?.detail
              ? resp.data.detail
              : "Error en la validación de los datos, verifique la información e intente nuevamente";
            return swal2.fire({
              icon: "error",
              title: "Error",
              text: errorDetail,
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 10000,
              timerProgressBar: true,
            });
          } else if (!resp?.status) {
            self.loading = false;
            return swal2.fire({
              icon: "error",
              title: "Error",
              text: "No se recibió respuesta del servidor, intente nuevamente",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 10000,
              timerProgressBar: true,
            });
          }
        } catch (error) {
          // Manejo de errores de red o inesperados
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "Error al conectar con el servidor, intente nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        self.loading = false;
    },
    setCurrentDocumentEdit(document) {
      this.currentDocumentEdit = document.id;
      this.currentDocumentPrice = document.price ? document.price.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',') : 0;
    },
    async updatePriceQuotation(document) {
      let self = this;
      if (!self.currentDocumentPrice || 
          self.currentDocumentPrice.replaceAll('.', '').replaceAll(",", ".") == 0 || 
          isNaN(Number(this.currentDocumentPrice.replaceAll(".", "").replaceAll(",", ".")))
        ) {
        return self.$swal.fire({
          icon: "error",
          title: "Error",
          text: "El precio debe ser mayor que 0",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });    
      }
      this.$swal
        .fire({
          icon: "info",
          title: `Confirma el precio para la cotización: <b>${
            document.document_name ? document.document_name : "-"
          }</b> de $${this.currentDocumentPrice}?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#1076D0",
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loadingDocument = true;
            const payload = {
              
              [document.document_name]: {
                action: 'update',
                comment: "Modificación de precio",
                selected: document.selected,
                unique_supplier: document.unique_supplier,
                supplier: document.supplier,
                type: document.document_type,
                unit_price: Number(self.currentDocumentPrice.replaceAll(".", "").replaceAll(",", ".")),
                coin: document.coin ? document.coin : "CLP",
              }
            }
            await this.updateService(payload);
          }
        });
    },
    async updateService(documents){
      this.loading = true;
      let payload = {
        quotation_id: this.requestId,
        title: this.currentService.title,
        description: this.currentService.name,
        documents: documents,
        user: this.user.email,
      };
      const resp = await this.sendUpdateService(payload);
      if (!resp || !resp.status || resp.status == 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intenta nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.loadingDocument = false;
        return this.loading = false;
      }
      if (resp.status == 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.loadingDocument = false;
        return this.loading = false;
      }
      if (resp.status == 200) {
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: `Cotización actualizada correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.currentDocumentEdit = null;
        this.currentDocumentPrice = null;
        this.$emit("updateDocumentsCurrentService");
      }
      this.loading = false;
    },
    async deleteFile({ id, file }) {
        swal2
          .fire({
            icon: "info",
            title: `¿Estás seguro de eliminar este archivo: ${file.name}`,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: "red",
            confirmButtonText: "Eliminar",
            cancelButtonText: `Cancelar`,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.currentService.documents = this.currentService.documents.filter(
                (document) => document.id !== id
              );
            }
          });
      },
      async deleteUploadFile(file) {
        swal2
          .fire({
            icon: "info",
            title: `¿Estás seguro de eliminar este documento: ${file.document_name}`,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: "red",
            confirmButtonText: "Eliminar",
            cancelButtonText: `Cancelar`,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.loading = true;
              const payload = {
              [file.document_name]: {
                action: 'delete',
                comment: "Eliminar Archivo",
                selected: file.selected,
                unique_supplier: file.unique_supplier,
                supplier: file.supplier,
                type: file.file_type,
                unit_price: file.unit_price,
                coin: file.coin ? file.coin : "CLP",
              }
            }
            await this.updateService(payload);
            }
          });
      },
      // Add Supplier
      async addSupplierSelected(payload) {
        let self = this
        if(this.onlyRut){
          this.onlyRut = false;
        }
        if(this.userCreateRequestQuote){
          this.currentService.documents.forEach((file) => {
            if (file.id == self.currentDocument.id) {
              file.supplier_name = payload.name ? payload.name : null;
              file.supplier_rut = payload.rut;
            }
          });
        }else {
          this.loadingDocument = true;
          await this.updateService({
              [this.currentDocument.document_name]: {
                action: 'update',
                comment: "Modificación de proveedor",
                selected: this.currentDocument.selected,
                unique_supplier: this.currentDocument.unique_supplier,
                supplier: payload.rut,
                type: this.currentDocument.document_type,
                unit_price: this.currentDocument.price ?
                   this.currentDocument.price : this.currentDocument.unit_price 
                   ? this.currentDocument.unit_price : 0,
                coin: this.currentDocument.coin ? this.currentDocument.coin : "CLP",
              }
            });
        }
        this.keyDocumentsTable++;
      },
      openModalAddSupplier({search, filterFrom}) {
        if(filterFrom == "rut"){
          this.$refs.tableAddSupplier.filters.rut = search;
          this.$refs.tableAddSupplier.showFilterName = false;
        }else{
          this.$refs.tableAddSupplier.filters.name = search;
          this.$refs.tableAddSupplier.showFilterRut = false;
        }
        this.$refs.tableAddSupplier.getSuppliers(
          1,
          false
        );
        this.dialogAddSupplier = true;
      },
      closeModalTableAddSupplier() {
        this.dialogAddSupplier = false;
      },
      openModalSearchSupplier(document) {
        this.currentDocument = null;
        this.currentDocument = document;
        this.dialogSearchSupplier = true;
      },
      closeModalSearchSupplier() {
        this.dialogSearchSupplier = false;
      },
      openModalCreateSupplierAndSetDocument(document){
        this.currentDocument = null;
        this.currentDocument = document;
        this.openModalCreateSupplier();
      },  
      openModalCreateSupplier(){
        this.dialogCreateSupplier = true;
      },
      closeModalCreateSupplier() {
        this.dialogCreateSupplier = false;
      },
      openModalSetOnlyRutSupplier(rut){
        if(rut){
          return this.addSupplierSelected({name: rut, rut: rut});
        }
        this.onlyRut = true;
        this.$refs.searchSupplier.rut = rut;
        this.dialogSearchSupplier = true;
      },
      // Validar si el usuario puede eliminar los archivos
      permissionToDeleteFile(document) {
        if(this.userCreateRequestQuote){
          return true
        }
        if(document && document.created_by == this.user.email){
          return true
        }
        if(document && this.currentRequest && document.created_by != this.currentRequest.created_by && this.currentRequest.created_by != this.user.email){
          return true
        }
        return false
      },
  
    },
    computed: {
      ...authUsuarioComputed,
      // Determina si el usuario puede subir archivos a la cotización basándose en
      // si tiene un usuario especializado asignado (requisito del backend).
      // IMPORTANTE: debe vivir en este único bloque `computed`; tener dos claves
      // `computed` en el mismo objeto de opciones hace que Vue descarte la primera
      // y este getter quede como `undefined` (el botón "Cargar Archivos" no se habilitaba).
      canUploadQuoteFiles() {
        // Si no hay cotización seleccionada, permitir subir
        if (!this.currentService) return true;
        // Si la cotización tiene un usuario especializado asignado, permitir subir
        if (this.currentService.assigned_user) return true;
        // Si es usuario crear cotización, permitir subir
        if (this.userCreateRequestQuote) return true;
        // Si no hay usuario especializado, bloquear subida y mostrar mensaje en UI
        return false;
      },
      currentServiceStatusIsQuotation() {
        return (
          this.currentService &&
          this.currentService.status ===
            QUOTE_CONSTANTS.quote_statuses_list.in_quotation
        );
      },
      currentServiceStatusIsQuotationOrInReview() {
        return (
          this.currentService &&
          (this.currentServiceStatusIsQuotation ||
            this.currentService.status ===
              QUOTE_CONSTANTS.quote_statuses_list.in_review)
        );
      },
      currentRequestStatusIsUserValidationVariant(){
        return (
          this.currentRequest &&
            this.currentRequest.status ===
              QUOTE_CONSTANTS.quote_statuses_list.user_validation_variant
        );
      },
      currentRequestStatusIsQuotation(){
        return (
          this.currentRequest &&
            this.currentRequest.status ===
              QUOTE_CONSTANTS.quote_statuses_list.in_quotation
        );
      },
      currentRequestStatusIsFinished(){
        return (
          this.currentRequest &&
            this.currentRequest.status ===
              QUOTE_CONSTANTS.quote_statuses_list.finished
        );
      },
      currentRequestStatusIsRejected(){
        return (
          this.currentRequest &&
            this.currentRequest.status ===
              QUOTE_CONSTANTS.quote_statuses_list.rejected
        );
      },

      activeManagmetFiles() {
        // Caso de Cotización por parte de compras
        if (
          ((this.currentServiceStatusIsQuotationOrInReview && !this.requestingUserModule))
        ) {
          return true
        }

        // Caso de Revisión por parte del usuario
         if (
          ((this.currentRequestStatusIsUserValidationVariant && this.requestingUserModule && !this.currentRequest.approved))
        ) {
          return true
        }

        return false

      },
      activeEditPriceAndSupplierFiles() {
        // Caso de Cotización por parte de compras
        if (
          ((this.currentServiceStatusIsQuotationOrInReview && !this.requestingUserModule))
        ) {
          return true
        }

        // Caso de Revisión por parte del usuario
        if (
          ((this.currentRequestStatusIsUserValidationVariant && this.requestingUserModule && !this.currentRequest.approved))
        ) {
          return true
        }

        return false
      },
      documentFilesFromCategory() {
        if (this.currentService) {
          if(this.userCreateRequestQuote){
            return this.currentService.documents.filter(
              (item) => item.category === this.tabsFiles
            );
          }else {
            return this.currentService.documents
            .map((document) => {
              document.category = REQUEST_SERVICE_CONSTANTS.getDocumentCategory(document.document_type, false);
              return document;
            })
            .filter((document) => document.category == this.tabsFiles)
            .sort((a, b) => a.document_name.localeCompare(b.document_name));
          }
        }
        return [];
      },
    },
  };
  </script>
  
  <style>
  .form-control-quantity {
    border: none;
    border-bottom: 1px solid gray;
    border-radius: 0;
    max-width: 120px;
  }
  </style>
  